import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/admin" replace />; // Redireciona para o login
  }

  return <Outlet />; // Renderiza o componente filho (Dashboard)
};

export default ProtectedRoute;